import React, { useState } from "react";
import { usePublishAssignmentMarkMutation } from "../../../features/assignmentMark/assignmentMarkApi";

export default function SingleAssignmentMark({ assignmentMark }) {
  const {
    title,
    createdAt,
    student_name,
    repo_link,
    mark: initialMark,
    status,
    id,
  } = assignmentMark || {};

  const [publishAssignmentMark, { isLoading }] =
    usePublishAssignmentMarkMutation();

  const [mark, setMark] = useState(initialMark || 100);

  const handlePublish = () => {
    publishAssignmentMark({
      id,
      data: {
        ...assignmentMark,
        mark: mark,
        status: "published",
      },
    });
  };

  const dateObj = new Date(createdAt);
  const formattedDate = dateObj.toLocaleString("en-US", {
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
    hour12: true,
  });

  //10 Mar 2023 10:58:13 PM
  return (
    <tr>
      <td className="table-td">{title}</td>
      <td className="table-td">{formattedDate}</td>
      <td className="table-td">{student_name}</td>
      <td className="table-td">{repo_link}</td>
      <td className="table-td" style={{ textAlign: "center" }}>
        {status === "published" ? (
          mark
        ) : (
          <div className="input-mark">
            <input
              max="100"
              value={mark}
              onChange={(e) => setMark(e.target.value)}
            />
            <button disabled={isLoading} onClick={handlePublish}>
              <svg
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="2"
                stroke="currentColor"
                className="w-6 h-6 text-green-500 cursor-pointer hover:text-green-400"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M4.5 12.75l6 6 9-13.5"
                />
              </svg>
            </button>
          </div>
        )}
      </td>
    </tr>
  );
}
